export enum GeneralActionTypes {
  SIDEBAR_STATUS = "SIDEBAR_STATUS",
  FILTER_STATUS = "FILTER_STATUS",
  LOADER_STATUS = "LOADER_STATUS",
  GET_COMPANIES = "GET_COMPANIES",
  GET_COMPANY_ASSETS = "GET_COMPANY_ASSETS",
  GET_SETTINGS = "GET_SETTINGS",
  GET_SMTP_SETTINGS = "GET_SMTP_SETTINGS",
  GET_GLOBAL_SETTINGS = "GET_GLOBAL_SETTINGS",
  UPDATE_SETTINGS = "UPDATE_SETTINGS",
  UPDATE_SMTP_SETTINGS = "UPDATE_SMTP_SETTINGS",
  UPDATE_GLOBAL_SETTINGS = "UPDATE_GLOBAL_SETTINGS",
  UPDATE_REVIEW = "UPDATE_REVIEW",
  SET_SELECTED_ROW = "SET_SELECTED_ROW",
  GET_USERS = "GET_USERS",
  GET_EVENTS = "GET_EVENTS",
  GET_ALERTS = "GET_ALERTS",
  GET_ASSETS = "GET_ASSETS",
  GET_ASSET_SITES = "GET_ASSET_SITES",
  GET_ASSET_GROUPS = "GET_ASSET_GROUPS",
  GET_ASSET_COMPUTERS = "GET_ASSET_COMPUTERS",
  GET_AUDITS = "GET_AUDITS",
  DELETE_ASSET_COMPUTERS = "DELETE_ASSET_COMPUTERS",
  GET_COMPUTER_LIST = "GET_COMPUTER_LIST",
  GET_COMPUTER_LIST_BY_USER = "GET_COMPUTER_LIST_BY_USER",
  GET_HASHES = "GET_HASHES",
  GET_SITES = "GET_SITES",
  GET_GROUPS = "GET_GROUPS",
  GET_PROPOSED_UNIQUE_BLOCKS = "GET_PROPOSED_UNIQUE_BLOCKS",
  GET_PERMISSION_LEVELS = "GET_PERMISSION_LEVELS",
  GET_REVIEW_STATUSES = "GET_REVIEW_STATUSES",
  GET_RISK_LEVELS = "GET_RISK_LEVELS",
  CREATE_REVIEW = "CREATE_REVIEW",
  CREATE_UNIQUE_BLOCK_REVIEW = "CREATE_UNIQUE_BLOCK_REVIEW",
  UPDATE_REVIEW_CHECKLIST_ITEM = "UPDATE_REVIEW_CHECKLIST_ITEM",
  GET_SECTIONS = "GET_SECTIONS",
  SET_SCOPE_DETAIL = "SET_SCOPE_DETAIL",
  GET_POLICY_CHECK_LIST = "GET_POLICY_CHECK_LIST",
  GET_REVIEW_CHECK_LIST = "GET_REVIEW_CHECK_LIST",
  SET_AGMS_BREADCRUMB_STATUS = "SET_AGMS_BREADCRUMB_STATUS",
  SET_AGMS_BREADCRUMB_DATA = "SET_AGMS_BREADCRUMB_DATA",
  CREATE_OTP = "CREATE_OTP",
  SET_COMPKEY = "SET_COMPKEY",
  SET_EXPORT_STATUS = "SET_EXPORT_STATUS",
  SET_EXPORT_DATA_LOADED = "SET_EXPORT_DATA_LOADED",
  SET_ROW_OPENED = "SET_ROW_OPENED",
  SET_SELECTED_DECISION = "SET_SELECTED_DECISION",
  GET_EVENT_LISTS = "GET_EVENT_LISTS",
  SET_ISCREATED_MODAL = "SET_ISCREATED_MODAL",
  SET_SCOPE_MODAL = "SET_SCOPE_MODAL",
  GET_PARTNERS = "GET_PARTNERS",
  CREATE_OR_EDIT_COMPANY = "CREATE_OR_EDIT_COMPANY",
  DELETE_COMPANY = "DELETE_COMPANY",
  GET_IGNORE_EVENT_LIST = "GET_IGNORE_EVENT_LIST",
  GET_TEMPLATE_IGNORE_EVENT_LIST = "GET_TEMPLATE_IGNORE_EVENT_LIST",
  GET_SEVERITY_EVENT_LIST = "GET_SEVERITY_EVENT_LIST",
  GET_TEMPLATE_SEVERITY_EVENT_LIST = "GET_TEMPLATE_SEVERITY_EVENT_LIST",
  GET_EVENT_POLICY_NAME = "GET_EVENT_POLICY_NAME",
  GET_SERVERS = "GET_SERVERS",
  GET_SERVER_BY_ID = "GET_SERVER_BY_ID",
  GET_COMPANY_SERVER_BY_ID = "GET_COMPANY_SERVER_BY_ID",
  DELETE_SERVER = "DELETE_SERVER",
  DELETE_SELECT_SERVER = "DELETE_SELECT_SERVER",
  GET_ZONES = "GET_ZONES",
  GET_GLOBAL_SERVER = "GET_GLOBAL_SERVER",
  CREATE_OR_UPDATE_SERVER = "CREATE_OR_UPDATE_SERVER",
  SELECT_OR_INHERIT_SERVER = "SELECT_OR_INHERIT_SERVER",
  GET_TEST_CONNECTION_BY_SERVERID = "GET_TEST_CONNECTION_BY_SERVERID",
  TEST_CONNECTION = "TEST_CONNECTION",
  UPDATE_APPGUARD_MAIN = "UPDATE_APPGUARD_MAIN",
  GET_OR_CREATE_APPGUARD_MAIN = "GET_OR_CREATE_APPGUARD_MAIN",
  RESET_TO_DEFAULT_APPGUARD_MAIN = "RESET_TO_DEFAULT_APPGUARD_MAIN",
  GET_APPGROUPS = "GET_APPGROUPS",
  CREATE_OR_UPDATE_APPGROUP = "CREATE_OR_UPDATE_APPGROUP",
  GET_APPGROUP_DETAIL = "GET_APPGROUP_DETAIL",
  DELETE_APPGROUP = "DELETE_APPGROUP",
  CREATE_OR_UPDATE_APPGROUP_REGISTRY = "CREATE_OR_UPDATE_APPGROUP_REGISTRY",
  GET_APPGROUP_REGISTRY_DETAIL = "GET_APPGROUP_REGISTRY_DETAIL",
  GET_APPGROUP_REGISTRY = "GET_APPGROUP_REGISTRY",
  CREATE_OR_UPDATE_APPGROUP_CODE_LOAD = "CREATE_OR_UPDATE_APPGROUP_CODE_LOAD",
  GET_APPGROUP_CODE_LOAD_DETAIL = "GET_APPGROUP_CODE_LOAD_DETAIL",
  GET_APPGROUP_CODE_LOAD = "GET_APPGROUP_CODE_LOAD",
  CREATE_OR_UPDATE_APPGROUP_CHILD_LAUNCH = "CREATE_OR_UPDATE_APPGROUP_CHILD_LAUNCH",
  GET_APPGROUP_CHILD_LAUNCH_DETAIL = "GET_APPGROUP_CHILD_LAUNCH_DETAIL",
  GET_APPGROUP_CHILD_LAUNCH = "GET_APPGROUP_CHILD_LAUNCH",
  CREATE_OR_UPDATE_APPGROUP_FILE_ACCESS = "CREATE_OR_UPDATE_APPGROUP_FILE_ACCESS",
  GET_APPGROUP_FILE_ACCESS_DETAIL = "GET_APPGROUP_FILE_ACCESS_DETAIL",
  GET_APPGROUP_FILE_ACCESS = "GET_APPGROUP_FILE_ACCESS",
  CREATE_OR_UPDATE_APPGROUP_PROCESS = "CREATE_OR_UPDATE_APPGROUP_PROCESS",
  GET_APPGROUP_PROCESS_DETAIL = "GET_APPGROUP_PROCESS_DETAIL",
  GET_APPGROUP_PROCESS = "GET_APPGROUP_PROCESS",
  EXPORT_APPGROUP = "EXPORT_APPGROUP",
  IMPORT_APPGROUP = "IMPORT_APPGROUP",
  GET_FOLDER_MAPS ="GET_FOLDER_MAPS",
  GET_ENUM_BY_NAME="GET_ENUM_BY_NAME",
  DELETE_APPGROUP_CHILD_LAUNCH="DELETE_APPGROUP_CHILD_LAUNCH",
  DELETE_APPGROUP_REGISTRY_ACCESS="DELETE_APPGROUP_REGISTRY_ACCESS",
  DELETE_APPGROUP_FILE_ACCESS="DELETE_APPGROUP_FILE_ACCESS",
  DELETE_APPGROUP_CODE_LOAD="DELETE_APPGROUP_CODE_LOAD",
  GET_PUBLISHER_LIST="GET_PUBLISHER_LIST",
  GET_ALL_GLOBAL_POLICY = "GET_ALL_GLOBAL_POLICY",
  GET_GLOBAL_POLICY_FILE_ACCESS = "GET_GLOBAL_POLICY_FILE_ACCESS",
  GET_GLOBAL_POLICY_FILE_ACCESS_DETAIL = "GET_GLOBAL_POLICY_FILE_ACCESS_DETAIL",
  GET_GLOBAL_POLICY_REGISTRY_ACCESS = "GET_GLOBAL_POLICY_REGISTRY_ACCESS",
  GET_GLOBAL_POLICY_REGISTRY_ACCESS_DETAIL = "GET_GLOBAL_POLICY_REGISTRY_ACCESS_DETAIL",
  CREATE_OR_UPDATE_GLOBAL_POLICY_REGISTRY = "CREATE_OR_UPDATE_GLOBAL_POLICY_REGISTRY",
  CREATE_OR_UPDATE_GLOBAL_POLICY_FILE_ACCESS = "CREATE_OR_UPDATE_GLOBAL_POLICY_FILE_ACCESS",
  DELETE_GLOBAL_POLICY_FILE_ACCESS="DELETE_GLOBAL_POLICY_FILE_ACCESS",
  DELETE_GLOBAL_POLICY_REGISTRY="DELETE_GLOBAL_POLICY_REGISTRY",
  CREATE_OR_UPDATE_GLOBAL_POLICY_CODE_LOAD = "CREATE_OR_UPDATE_GLOBAL_POLICY_CODE_LOAD",
  GET_GLOBAL_POLICY_CODE_LOAD = "GET_GLOBAL_POLICY_CODE_LOAD",
  DELETE_GLOBAL_POLICY_CODE_LOAD="DELETE_GLOBAL_POLICY_CODE_LOAD",
  DELETE_APPGROUP_PROCESS = "DELETE_APPGROUP_PROCESS",
  GET_ALL_FILE_TYPES_POLICIES = "GET_ALL_FILE_TYPES_POLICIES",
  CREATE_OR_UPDATE_FILE_TYPES_POLICY = "CREATE_OR_UPDATE_FILE_TYPES_POLICY",
  GET_FILE_TYPES_POLICY_DETAIL = "GET_FILE_TYPES_POLICY_DETAIL",
  DELETE_FILE_TYPES_POLICY = "DELETE_FILE_TYPES_POLICY",
  DELETE_FILE_TYPES_POLICY_DAO = "DELETE_FILE_TYPES_POLICY_DAO",
  GET_ALL_FILE_TYPES_POLICIES_TEMPLATE = "GET_ALL_FILE_TYPES_POLICIES_TEMPLATE",
  CREATE_OR_UPDATE_FILE_TYPES_POLICY_TEMPLATE = "CREATE_OR_UPDATE_FILE_TYPES_POLICY_TEMPLATE",
  DELETE_FILE_TYPES_POLICY_DAO_TEMPLATE = "DELETE_FILE_TYPES_POLICY_DAO_TEMPLATE",
  GET_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE = "GET_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE",
  CREATE_OR_UPDATE_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE = "CREATE_OR_UPDATE_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE",
  DELETE_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE = "DELETE_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE",
  GET_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE = "GET_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE",
  CREATE_OR_UPDATE_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE = "CREATE_OR_UPDATE_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE",
  DELETE_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE = "DELETE_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE",
  GET_GLOBAL_POLICY_CODE_LOAD_TEMPLATE = "GET_GLOBAL_POLICY_CODE_LOAD_TEMPLATE",
  CREATE_OR_UPDATE_GLOBAL_POLICY_CODE_LOAD_TEMPLATE = "CREATE_OR_UPDATE_GLOBAL_POLICY_CODE_LOAD_TEMPLATE",
  DELETE_GLOBAL_POLICY_CODE_LOAD_TEMPLATE = "DELETE_GLOBAL_POLICY_CODE_LOAD_TEMPLATE",
  GET_APPGROUPS_TEMPLATE = "GET_APPGROUPS_TEMPLATE",
  GET_APPGROUP_DETAIL_TEMPLATE = "GET_APPGROUP_DETAIL_TEMPLATE",
  CREATE_OR_UPDATE_APPGROUP_TEMPLATE = "CREATE_OR_UPDATE_APPGROUP_TEMPLATE",
  DELETE_APPGROUP_TEMPLATE = "DELETE_APPGROUP_TEMPLATE",
  GET_APPGROUP_PROCESS_TEMPLATE = "GET_APPGROUP_PROCESS_TEMPLATE",
  DELETE_APPGROUP_PROCESS_TEMPLATE = "DELETE_APPGROUP_PROCESS_TEMPLATE",
  CREATE_OR_UPDATE_APPGROUP_PROCESS_TEMPLATE = "CREATE_OR_UPDATE_APPGROUP_PROCESS_TEMPLATE",
  GET_APPGROUP_FILE_ACCESS_TEMPLATE = "GET_APPGROUP_FILE_ACCESS_TEMPLATE",
  CREATE_OR_UPDATE_APPGROUP_FILE_ACCESS_TEMPLATE = "CREATE_OR_UPDATE_APPGROUP_FILE_ACCESS_TEMPLATE",
  DELETE_APPGROUP_FILE_ACCESS_TEMPLATE="DELETE_APPGROUP_FILE_ACCESS_TEMPLATE",
  GET_APPGROUP_REGISTRY_TEMPLATE = "GET_APPGROUP_REGISTRY_TEMPLATE",
  CREATE_OR_UPDATE_APPGROUP_REGISTRY_TEMPLATE = "CREATE_OR_UPDATE_APPGROUP_REGISTRY_TEMPLATE",
  DELETE_APPGROUP_REGISTRY_ACCESS_TEMPLATE="DELETE_APPGROUP_REGISTRY_ACCESS_TEMPLATE",
  GET_APPGROUP_CODE_LOAD_TEMPLATE = "GET_APPGROUP_CODE_LOAD_TEMPLATE",
  CREATE_OR_UPDATE_APPGROUP_CODE_LOAD_TEMPLATE = "CREATE_OR_UPDATE_APPGROUP_CODE_LOAD_TEMPLATE",
  DELETE_APPGROUP_CODE_LOAD_TEMPLATE="DELETE_APPGROUP_CODE_LOAD_TEMPLATE",
  GET_APPGROUP_CHILD_LAUNCH_TEMPLATE = "GET_APPGROUP_CHILD_LAUNCH_TEMPLATE",
  CREATE_OR_UPDATE_APPGROUP_CHILD_LAUNCH_TEMPLATE = "CREATE_OR_UPDATE_APPGROUP_CHILD_LAUNCH_TEMPLATE",
  DELETE_APPGROUP_CHILD_LAUNCH_TEMPLATE="DELETE_APPGROUP_CHILD_LAUNCH_TEMPLATE",
  GET_FILE_TYPES_POLICY_DETAIL_TEMPLATE = "GET_FILE_TYPES_POLICY_DETAIL_TEMPLATE",
  GET_TEMPLATE_PUBLISHER_LIST = "GET_TEMPLATE_PUBLISHER_LIST",
  GET_APPGROUP_INHERITANCE_INFO = "GET_APPGROUP_INHERITANCE_INFO",
  GET_GLOBAL_POLICY_INHERITANCE_INFO = "GET_GLOBAL_POLICY_INHERITANCE_INFO",
  GET_FILE_TYPES_POLICY_INHERITANCE_INFO = "GET_FILE_TYPES_POLICY_INHERITANCE_INFO",
  GET_APPGROUP_INHERITANCE_INFO_BY_GROUP_ID = "GET_APPGROUP_INHERITANCE_INFO_BY_GROUP_ID",
  RESET_TO_DEFAULT_GLOBAL_POLICY = "RESET_TO_DEFAULT_GLOBAL_POLICY",
  RESET_TO_DEFAULT_FILE_TYPES_POLICY = "RESET_TO_DEFAULT_FILE_TYPES_POLICY",
  RESET_TO_DEFAULT_APP_GROUP = "RESET_TO_DEFAULT_APP_GROUP",
  TEMPLATE_RESET_TO_DEFAULT_GLOBAL_POLICY = "TEMPLATE_RESET_TO_DEFAULT_GLOBAL_POLICY",
  TEMPLATE_RESET_TO_DEFAULT_FILE_TYPES_POLICY = "TEMPLATE_RESET_TO_DEFAULT_FILE_TYPES_POLICY",
  TEMPLATE_RESET_TO_DEFAULT_APP_GROUP = "TEMPLATE_RESET_TO_DEFAULT_APP_GROUP",
  GET_PROCESS_BY_FİLE_ACCESS_RULEGUID = "GET_PROCESS_BY_FİLE_ACCESS_RULEGUID",
}
